import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, OnClickOut, Popover, TeamLogo } from 'react-fast-ui';
import cx from 'classnames';
import LoggedInUserName from './LoggedInUserName';
import LogoutLink from './LogoutLink';
import SupportLink from './SupportLink';
import AdminLink from './AdminLink';
import FastScoutLink from './FastScoutLink';
import FastAccessLink from './FastAccessLink';
import FastRecruitLink from './FastRecruitLink';
import { connect } from 'react-redux';

const FM_LOGO = require('../../../res/fast-model-logo-full.svg');

const BUTTON_CLASSES = cx(
  'color-white',
  'header-menu-drop-down',
  'md-font'
);

const NAV_CX = cx(
  'align-items-center',
  'display-flex',
  'justify-content-space-between',
  'flex-grow-1',
  'nav',
  'header-menu-item',
);
const LI_CX = cx(
  'full-height',
  'display-flex',
  'align-items-center',
  'mg-right-sm',
  'mg-left-sm',
);

const AccountDropdown = ({ onClose }) => (
  <OnClickOut onClickOut={onClose} portalClass='account-menu'>
    <div
      className={BUTTON_CLASSES}
      style={{ width: 170, paddingLeft: 0 }}
    >
      <SupportLink className="display-block pd-left-lg pd-right-lg color-white"/>
      <LogoutLink className="display-block color-white"/>
    </div>
  </OnClickOut>
);

const AccountProductsDropdown = ({ products, onClose, open }) => {
  return (
    <OnClickOut onClickOut={onClose} portalClass='accounts-product-dropdown'>
      <div
        className={BUTTON_CLASSES}
        style={{
          width: 226,
          display: open ? 'block' : 'none'
        }}>
        {
          products.map((product) => {
            switch (product) {
              case 'FASTSCOUT2':
                return (
                  <FastScoutLink key='scout' className="display-flex" style={{ marginLeft: -2, paddingRight: 55 }}/>
                );
              case 'FASTRECRUIT':
                return (
                  <FastRecruitLink key='recruit' style={{ marginLeft: -2 }} className="display-flex"/>
                );
              case 'FASTACCESS':
                return (
                  <FastAccessLink key='access' style={{ marginLeft: -2 }} className="display-flex"/>
                );
              default:
                return (
                  <AdminLink className="display-flex" style={{ paddingRight: 55 }}/>
                );
            }
          })
        }
        <AdminLink className="display-flex" style={{ paddingRight: 55 }}/>

      </div>
    </OnClickOut>
  );
};

const mapStateToProps = (store) => ({
  team: store.team,
});

class TopBarNavigation extends Component {
  static contextTypes = {
    contentWidth: PropTypes.number,
    ngUser: PropTypes.object,
    dao: PropTypes.object,
    router: PropTypes.object,
  };

  state = {
    accountDrawerOpen: false,
    accountsProductDrawerOpen: false,
  };

  // handlers
  toggleAccountPopover = accountDrawerOpen => this.setState({ accountDrawerOpen: !accountDrawerOpen });
  toggleAccountProductsPopover = accountsProductDrawerOpen => this.setState({
    accountsProductDrawerOpen:
      !accountsProductDrawerOpen
  });

  getAccountsProducts = () => {
    const { ngUser } = this.context;

    return [ 'FASTSCOUT2', 'FASTRECRUIT', 'FASTACCESS' ].filter(productKey => !!ngUser.availableProducts[ productKey ]);
  };

  // lifecycle
  render() {
    const { team } = this.props;
    const { accountDrawerOpen, accountsProductDrawerOpen } = this.state;

    const styles = { margin: 'auto' };

    return (
      <div
        className="top-navigation-bar flex-grow-1 bg-color-fastmodel-gray full-height"
        style={{ backgroundColor: '#000' }}>
        <nav className={NAV_CX} id='navbar' role='nav' style={styles}>
          <div style={{ width: '25%' }} className='align-items-center display-flex full-height' title={__VERSION__}>
            <div
              key="available-products-menu"
              onClick={() => this.toggleAccountProductsPopover(this.state.accountsProductDrawerOpen)}
              className={cx('display-flex full-height align-items-center cursor-pointer accounts-product-dropdown',
                { open: accountsProductDrawerOpen })}
              id="accountsProductDropdown"
            >
              <Popover
                style={{ position: 'absolute' }}
                arrowClassName="visibility-hidden"
                className="full-height"
                open={accountsProductDrawerOpen}
                popoverStyle={{ top: 44, left: 0 }}
                defaultPlacement="bottom"
                content={<AccountProductsDropdown
                  open={accountsProductDrawerOpen}
                  products={this.getAccountsProducts()}
                  onClose={() => this.setState({ accountsProductDrawerOpen: false })}
                />}
              >
                <div
                  className="display-flex align-items-center"
                  style={{
                    color: 'white',
                    fontSize: 15,
                  }}
                  id='currentLoggedProduct'
                >
                  <img
                    alt="adminportal"
                    key="admin=portal-logo"
                    style={{ marginLeft: 10, height: 41, width: 'auto' }}
                    src={FM_LOGO}/>
                  {<Icon name="caret-down" className="mg-left-sm" style={{
                    marginLeft: -10,
                    color: '#FFFFFF'
                  }}/>}
                </div>
              </Popover>
            </div>
          </div>
          <div
            className="display-flex flex-direction-row futura-pt-md color-white full-height align-items-center"
            style={{ fontSize: 15, width: '25%', justifyContent: 'flex-end' }}>
            <div className="full-height pd-left-xl pd-right-md">
              <div
                key="account-menu"
                className="display-flex full-height align-items-center cursor-pointer account-menu"
                onClick={() => this.toggleAccountPopover(this.state.accountDrawerOpen)}
                name="accountDropdown"
                id="accountDropdown">
                <Popover
                  arrowClassName="visibility-hidden"
                  style={{ position: 'absolute' }}
                  className="full-height"
                  open={accountDrawerOpen}
                  popoverStyle={{}}
                  defaultPlacement="bottom"
                  content={<AccountDropdown onClose={() => this.setState({ accountDrawerOpen: false })}/>}
                >
                  <div className="display-flex align-items-center text-transform-uppercase">
                    <LoggedInUserName className={LI_CX} style={{ paddingLeft: 0, whiteSpace: 'nowrap' }}/>
                    <span style={{ color: '#383838' }}>|</span>
                    {team ? <TeamLogo url={team.getLogoHref()} height={30}/> : null}
                    <Icon name="caret-down" className="mg-left-sm" style={{ paddingTop: 4 }}/>
                  </div>
                </Popover>
              </div>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

export default connect(mapStateToProps)(TopBarNavigation);